import { convertAttributesToBoolean, mapKeysToCamelCase } from '@skytech/utils'

import { get } from '@/util/auth'

import { API_ROUTE_SUBSCRIPTION_SETUP } from './api-routes'

type SubscriptionDepartmentOriginal = {
  id: number
  code: string
  name: string
  customer_id: number
  customer_head_id: number
  customer_name: string
  org_no: string
  isGlobal: 0 | 1
  allow_private_number: boolean
  allow_subscriptions: boolean
  allowEsim: boolean
  country_id: number
  customer_has_leasing?: boolean
}

type TelePolicyOriginal = {
  department_id: number
  customer_name: string
  customer_id: number
  customer_head_id: number
  id: number
  name: string
  isGlobal: 0 | 1
}

type DevicePolicyOriginal = {
  department_id: number
  customer_name: string
  customer_id: number
  customer_head_id: number
  id: number
  name: string
  covered_amount: number
  isGlobal: 0 | 1
}

type SubscriptionSetupOriginal = {
  departments: SubscriptionDepartmentOriginal[]
  tele_policies: TelePolicyOriginal[]
  device_policies: DevicePolicyOriginal[]
}

export const commonSubscriptionResources = {
  getSetup: async () => {
    const setup = await get<SubscriptionSetupOriginal>(API_ROUTE_SUBSCRIPTION_SETUP)
    const camelCaseSetup = mapKeysToCamelCase(setup)
    const parsedTelePolicies = camelCaseSetup.telePolicies.map(policy =>
      convertAttributesToBoolean(policy, 'isGlobal')
    )
    const parsedDevicePolicies = camelCaseSetup.devicePolicies.map(policy =>
      convertAttributesToBoolean(policy, 'isGlobal')
    )
    const parsedSetup = {
      ...camelCaseSetup,
      telePolicies: parsedTelePolicies,
      devicePolicies: parsedDevicePolicies,
    }
    return parsedSetup
  },
}

export type SubscriptionSetup = Awaited<ReturnType<typeof commonSubscriptionResources.getSetup>>
export type SubscriptionDevicePolicy = SubscriptionSetup['devicePolicies'][number]
export type SubscriptionTelePolicy = SubscriptionSetup['telePolicies'][number]
export type SubscriptionDepartment = SubscriptionSetup['departments'][number]
